/**
 * 微信配置
 */
import { baseURL } from '@/api/url';
const wxConfig = {
  appId: 'wxdd743090fb881eb1',
  // safeDomain: 'http://www.jingxuanwenhua.com/wechat/callback'
  safeDomain: baseURL + '/wechat/callback'
};
export default wxConfig;
